import { getGuid } from 'owa-guid';
import { is3SServiceAvailable } from 'owa-search';
import {
    lazyLogLocalContentDataSource,
    LocalContentInstrumentationContext,
    LocalContentProvider,
    LocalContentType,
    Suggestion,
    SuggestionKind,
    SubstrateSearchScenario,
} from 'owa-search-service';
import {
    lazyLogClientDataSource,
    ClientDataSourceEvent,
    Results,
    ItemType,
} from 'owa-search-instrumentation';
import { isFeatureEnabled } from 'owa-feature-flags';

export function logClientSuggestions(
    traceId: string,
    conversationId: string,
    logicalId: string,
    instrumentationContext: {
        [providerName: string]: LocalContentInstrumentationContext[];
    }
) {
    if (is3SServiceAvailable()) {
        if (isFeatureEnabled('sea-instv2')) {
            Object.keys(instrumentationContext).forEach(providerName => {
                const resultList = getResultList(instrumentationContext[providerName]);
                const clientDataSourceEvent: ClientDataSourceEvent = {
                    traceId: traceId,
                    userId: null,
                    tenantId: null,
                    conversationId: conversationId,
                    logicalId: logicalId,
                    providerName: providerName,
                    results: resultList,
                };
                lazyLogClientDataSource.importAndExecute(
                    SubstrateSearchScenario.Mail,
                    clientDataSourceEvent
                );
            });
        } else {
            Object.keys(instrumentationContext).forEach(providerName => {
                lazyLogLocalContentDataSource.importAndExecute(
                    traceId,
                    providerName as LocalContentProvider,
                    instrumentationContext[providerName],
                    SubstrateSearchScenario.Mail
                );
            });
        }
    }
}

const getResultList = (instrumentationContext: LocalContentInstrumentationContext[]) => {
    const resultList: Results[] = [];

    instrumentationContext.forEach(context => {
        resultList.push({
            referenceId: context.localContentId,
            type: context.contentType as ItemType,
            entityId: context.entityId,
        });
    });
    return resultList;
};

export function createClientSuggestionInstrumentationContext(
    clientSuggestions: Suggestion[],
    type: LocalContentType
): LocalContentInstrumentationContext[] {
    const localContentInstrumentationContexts: LocalContentInstrumentationContext[] = [];

    clientSuggestions.forEach(clientSuggestion => {
        localContentInstrumentationContexts.push({
            localContentId: getGuid(),
            entityId: clientSuggestion.ReferenceId,
            contentType: type,
        });
    });

    return localContentInstrumentationContexts;
}

export function getLocalContentInstrumentationType(
    suggestionKind: SuggestionKind
): LocalContentType {
    switch (suggestionKind) {
        case SuggestionKind.Category:
            return 'category';
        case SuggestionKind.TrySuggestion:
            return 'try';
        case SuggestionKind.WebSearch:
            return 'web';
    }

    return 'unknown';
}
